import { render, staticRenderFns } from "./AdditionalOptions.vue?vue&type=template&id=5d6ac100&scoped=true&"
import script from "./AdditionalOptions.vue?vue&type=script&lang=ts&"
export * from "./AdditionalOptions.vue?vue&type=script&lang=ts&"
import style0 from "./AdditionalOptions.vue?vue&type=style&index=0&id=5d6ac100&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../home/bearlogin/development/pinq-project/mono2/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6ac100",
  null
  
)

export default component.exports